module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"history_title":"개인정보처리방침 변경 이력","policy_title":"개인정보 처리 방침"},"en":{"history_title":"History of SK Pinx Policy","policy_title":"Privacy Policy"},"ja":{}}')
  delete Component.options._Ctor
}
